import {CiDumbbell} from "react-icons/ci"
import {BsHeartPulse} from "react-icons/bs"
import {BiTimeFive} from "react-icons/bi"
import {AiOutlineArrowRight} from "react-icons/ai"

import img1 from "../assets/img-8.jpg"
import img2 from "../assets/img-9.jpg"
import img3 from "../assets/img-10.jpg"
import img4 from "../assets/img-11.jpg"
import img5 from "../assets/img-12.jpg"

import img6 from "../assets/img-7.jpg"
import img7 from "../assets/img-15.jpg"
import img8 from "../assets/img-9.jpg"

// import img9 from "../assets/img-20.jpg"
// import img10 from "../assets/img-21.jpg"



export const navLinks = [
    {label:"Home",href:"#home"},
    {label:"About",href:"#about"},
    {label:"Services",href:"#services"},
    // {label:"Schedule",href:"#schedule"},
    {label:"Gallery",href:"#gallery"},
    {label:"Blog",href:"#blog"},
    {label:"Contact",href:"#contact"}
]

export const services = [
    {
        icon:<CiDumbbell />,
        label:"QUALITY EQUIPMENT",
        desc:"The sea freight service has grown consider ably in recent years. We spend timetting to kn.",
        btnDec:"DISCOVER MORE ABOUT US",
        btnIcon:<AiOutlineArrowRight />
    },
    {
        icon:<BsHeartPulse />,
        label:"HEALTH CARING",
        desc:"The sea freight service has grown consider ably in recent years. We spend timetting to kn.",
        btnDec:"DISCOVER MORE ABOUT US",
        btnIcon:<AiOutlineArrowRight />
    },
    {
        icon:<BiTimeFive />,
        label:"GYM STRATEGIES",
        desc:"The sea freight service has grown consider ably in recent years. We spend timetting to kn.",
        btnDec:"DISCOVER MORE ABOUT US",
        btnIcon:<AiOutlineArrowRight />
    },
    {
        icon:<BiTimeFive />,
        label:"BLOGS & FITNESS STORIES",
        desc:"T Your Source for Fitness Inspiration and Knowledge.",
        btnDec:"DISCOVER MORE ABOUT US",
        btnIcon:<AiOutlineArrowRight />
    }
]


export const client = [
    {
        id:1,
        desc:'"Brook presents your services with flexible, convenient and cdpose layouts. You can select your favorite layouts & elements for cular ts with unlimited ustomization possibilities. Pixel-perfect replica;ition of thei designers ijtls intended csents your se."',
        img:img1,
        clientName:"Butler"
    },
    {
        id:2,
        desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus consectetur, magnam eos optio laboriosam quaerat voluptates! Inventore molestiae voluptatibus repudiandae quos blanditiis, soluta ratione? Totam quos voluptas a laborum exercitationem",
        img:img2,
        clientName:"Chiris Harris"
    },
    {
        id:3,
        desc:'"Brook presents your services with flexible, convenient and cdpose layouts. You can select your favorite layouts & elements for cular ts with unlimited ustomization possibilities. Pixel-perfect replica;ition of thei designers ijtls intended csents your se."',
        img:img3,
        clientName:"Martin"
    },
    {
        id:4,
        desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus consectetur, magnam eos optio laboriosam quaerat voluptates! Inventore molestiae voluptatibus repudiandae quos blanditiis, soluta ratione? Totam quos voluptas a laborum exercitationem",
        img:img4,
        clientName:"Thomos"
    },
    {
        id:5,
        desc:'"Brook presents your services with flexible, convenient and cdpose layouts. You can select your favorite layouts & elements for cular ts with unlimited ustomization possibilities. Pixel-perfect replica;ition of thei designers ijtls intended csents your se."',
        img:img5,
        clientName:"Dravid"
    }
]

export const teamMembers =[
    {
        img:img6,
        role:"Dietician",
        name:"Jyoti Gupta"
    },
    {
        img:img7,
        role:"Fitness Trainer",
        name:"Nikhil Singh"
    },
    {
        img:img8,
        role:"Yoga Trainer",
        name:"Kriti Tiwari"
    },
]

export const blog = [
    {   vid:"https://www.youtube.com/embed/wnHW6o8WMas",
        // role:"Creative director",
        desc:"The body achieves what the mind believes."
    },
    {
        vid:"https://www.youtube.com/embed/IKZtj-5LNeo",
        // role:"Creative director",
        desc:"Don’t stop until you’re proud."
    },
    {   vid:"https://www.youtube.com/embed/jVd2C-B5RXc",
        // role:"Creative director",
        desc:"Push yourself because no one else is going to do it for you."
    },
    {
        vid:"https://www.youtube.com/embed/tA8E4l8Dj34",
        // role:"Creative director",
        desc:"Success starts with self-discipline."
    }
]

export const footer = [
    {
        title:"COMPANY",
        footerLinks:[  
            {link:"About Us"},
            {link:"Company"},
            {link:"Blog"},
            {link:"Privacy Policy"}
        ]
    },
    {
        title:"FACILITIES",
        footerLinks:[
            {link:"Gym Equipments"},
            {link:"Search best Gyms nearby"},
            {link:"Strategies"},
            {link:"Workout Planner"}
        ]
    },
    // {
    //     title:"RESOURCES",
    //     footerLinks:[
    //         {link:"Home Insurance"},
    //         {link:"Travel Insurance"},
    //         {link:"Car Insurance"},
    //         {link:"Business Insurance"},
    //         {link:"Heal Insurance"}
    //     ]
    // }
]

// DashBoards Data

export const progressData = [
    {
      title: 'Calories',
      value: 1200,
      target: 2000,
      unit: 'kcal',
      color: ['#FF8A80', '#FF5252'], // Gradient from light to dark red
      icon: 'calories',
    },
    {
      title: 'Water',
      value: 1.5,
      target: 2.5,
      unit: 'L',
      color: ['#80D8FF', '#40C4FF'], // Gradient from light to dark blue
      icon: 'water',
    },
    {
      title: 'Sleep',
      value: 6,
      target: 8,
      unit: 'hours',
      color: ['#A7FFEB', '#1DE9B6'], // Gradient from light to dark teal
      icon: 'sleep',
    },
    {
      title: 'Workout',
      value: 30,
      target: 60,
      unit: 'mins',
      color: ['#FF80AB', '#FF4081'], // Gradient from light to dark pink
      icon: 'workout',
    },
    {
      title: 'Weight',
      value: 70,
      target: 65,
      unit: 'kg',
      color: ['#FFEB3B', '#FBC02D'], // Gradient from light to dark yellow
      icon: 'weight',
    },
    {
      title: 'Steps',
      value: 7000,
      target: 10000,
      unit: 'steps',
      color: ['#FFD54F', '#FFB300'], // Gradient from light to dark amber
      icon: 'steps',
    },
    {
      title: 'Heart Rate',
      value: 70,
      target: 60,
      unit: 'bpm',
      color: ['#EF9A9A', '#E57373'], // Gradient from light to dark light red
      icon: 'heart',
    },
    {
      title: 'Stress Level',
      value: 3,
      target: 1,
      unit: 'level',
      color: ['#B39DDB', '#7E57C2'], // Gradient from light to dark purple
      icon: 'stress',
    },
  ];
  